import { render } from "./TrocaSenha.vue?vue&type=template&id=76ab20c6"
import script from "./TrocaSenha.vue?vue&type=script&lang=js"
export * from "./TrocaSenha.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__